export default {
    items: [
        {
            name: 'Главная',
            url: '/home',
            icon: 'icon-speedometer',
        },
    ]
}